import axios from 'axios';

export default {
  state: {
    productsSimilar: {},
    loading: false,
    error: null,
    productsSimilarLoaded: false
  },
  mutations: {
    SET_PRODUCTS_SIMILAR(state, product) {
      state.productsSimilar = product;
      state.productsSimilarLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_PRODUCTS_SIMILAR_LOADING(state, status) {
      state.productsSimilarLoading = status;
    },
    SET_PRODUCTS_SIMILAR_ERROR(state, error) {
      state.productsSimilarError = error;
    },
    UNSET_PRODUCTS_SIMILAR(state) {
      state.productsSimilarLoaded = false;
      state.productsSimilarLoading = false;
      state.productsSimilar = [];
    },
  },
  actions: {
    async fetchProductsSimilar({ commit, state }, id) {
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.product) {
        //return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_PRODUCTS_SIMILAR_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/detail/'+id+'/similar/');
        commit('SET_PRODUCTS_SIMILAR', response.data.data);
        commit('SET_PRODUCTS_SIMILAR_ERROR', null);
      } catch (error) {
        commit('SET_PRODUCTS_SIMILAR_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching product:', error);
      } finally {
        commit('SET_PRODUCTS_SIMILAR_LOADING', false);
      }
    }
  },
  getters: {
    productsSimilar: state => state.productsSimilar,
    productsSimilarLoading: state => state.productsSimilarLoading,
    productsSimilarError: state => state.productsSimilarError,
    productsSimilarLoaded: state => state.productsSimilarLoaded
  }
}